import React, { useEffect, useState } from "react";
import axios from "axios";
import "../../scss/News.css";
import {apiKey2 } from "../API";

const NewsList = ({ topicName, pageSize, sendData  }) => {
  const [loading, setLoading] = useState(true);
  const [articles, setArticles] = useState([]);
  // const [totalResult, setTotalResult] = useState(0);

  useEffect(() => {
    setLoading(true);
    axios
      .get(
        `https://newsapi.org/v2/everything?q=${topicName}&pageSize=${pageSize}&apiKey=${apiKey2}`
      )
      .then((response) => {
        setArticles(response.data.articles);
        // setTotalResult(response.data.totalResults);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }, [topicName, pageSize]);

  useEffect(() => {
    sendData(articles);
  }, [articles, sendData]);

  const handleReadArticle = (url) => {
    window.open(url, "_blank");
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.getFullYear();
    const time = date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });

    return `${day}-${month}-${year} | ${time}`;
  };

  return (
    <div className="News">
      
      {loading ? (
        <div className="Spinner">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/c/c7/Loading_2.gif?20170503175831"
            alt="loader"
          />
        </div>
      ) : (
        articles.map((article, index) => (
          <div key={index} className="Article">
            <p className="date">{formatDate(article.publishedAt)}</p>
            <h4>{article.author}</h4>
            <h2 className="Article-title">{article.title}</h2>
            <img
              src={article.urlToImage}
              alt={article.title}
              className="Article-image"
            />
            <p className="Article-description">{article.description}</p>

            <button
              className="Read-button"
              onClick={() => handleReadArticle(article.url)}
            >
              {" "}
              Read
            </button>
          </div>
        ))
      )}
    </div>
  );
};

export default NewsList;
